import { defineStore } from 'pinia';

// eslint-disable-next-line import/prefer-default-export
export const useCustomerProfileViewStore = defineStore({
	id: 'customer-profile-view',
	state: () => ({
		modalsConditions: {
			nip: {
				isChecked: false,
				wasShown: false,
			},
			expressPhoto: {
				isChecked: false,
				wasShown: false,
			},
			promotionalAP: {
				isChecked: false,
				wasShown: false,
			},
		},
		isInRecommendationPromotion: false,
		recommendationPromotionEndDate: '',
		isInApPromotionalCampaign: false,
	}),
	actions: {
		async inApPromotionalCampaign() {
			try {
				const response = await fetch('/customer/in-ap-promotional-campaign.do');
				const data = await response.json();
				this.isInApPromotionalCampaign = data.inApPromotionalCampaign;
			} catch (error) {
				console.error('Error in customerProfileView.ts:', error);
			}
		},
	},
});
